// extracted by mini-css-extract-plugin
export default {"container":"_la-z","creativeContainer":"ama-z","copy":"bma-z","cta":"cma-z","disabled":"dma-z","flipped":"ema-z","productCard":"fma-z"};